<template>
    <v-list
        class="evaluation-tree"
        expand
        dark
        :ripple="false"
        two-line
    >
        <search-field-evaluation
            v-for="searchField in searchFields"
            :key="searchField.id"
            :searchField="searchField"
            :open="open"
        />
    </v-list>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import SearchFieldEvaluation from './search-field.vue'

@Component({
    components: {
        SearchFieldEvaluation
    }
})
export default class EvaluationsIndex extends Vue {
  @Prop({ type: Array, required: true }) searchFields
  @Prop({ type: String, default: () => null }) open
}
</script>
